/**
=========================================================
* Soft UI Dashboard PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Components
import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";

function HelpModalScreen() {
  const { t } = useTranslation(["help"]);

  return (
    <Box sx={{ overflow: "scroll", overflowX: "hidden", maxHeight: "85vh", padding: "1rem" }}>
      <Typography variant="h1" mb={2}>
        {t("dso.title")}
      </Typography>
      <hr />

      {/* Injeção na Rede Total */}
      <Typography variant="h3" mt={4} ml={2}>
        {t("dso.analytics.sections.total_grid_injection.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("dso.analytics.sections.total_grid_injection.body")}
        </Box>
      </Typography>

      {/* Excedente Total */}
      <Typography variant="h3" mt={4} ml={2}>
        {t("dso.analytics.sections.total_surplus.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("dso.analytics.sections.total_surplus.body")}
        </Box>
      </Typography>

      {/* Autoconsumo Coletivo Total */}
      <Typography variant="h3" mt={4} ml={2}>
        {t("dso.analytics.sections.total_collective_sc.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("dso.analytics.sections.total_collective_sc.body")}
        </Box>
      </Typography>

      {/* Autoconsumo Total RESP */}
      <Typography variant="h3" mt={4} ml={2}>
        {t("dso.analytics.sections.total_resp_sc.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("dso.analytics.sections.total_resp_sc.body")}
        </Box>
      </Typography>

      {/* Evolução Energética Agregada */}
      <Typography variant="h3" mt={4} ml={2}>
        {t("dso.analytics.sections.agg_evolution.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("dso.analytics.sections.agg_evolution.body")}
        </Box>
      </Typography>

      {/* Injeção por Contador */}
      <Typography variant="h3" mt={4} ml={2}>
        {t("dso.analytics.sections.by_meter_injection.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("dso.analytics.sections.by_meter_injection.body")}
        </Box>
      </Typography>

      {/* Consumo por Contador */}
      <Typography variant="h3" mt={4} ml={2}>
        {t("dso.analytics.sections.by_meter_consumption.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("dso.analytics.sections.by_meter_consumption.body")}
        </Box>
      </Typography>

      {/* Perfil Energético Contador */}
      <Typography variant="h3" mt={4} ml={2}>
        {t("dso.analytics.sections.meter_profile.title")}
      </Typography>
      <Typography variant="text" fontSize="1rem">
        <Box ml={4} mt={2}>
          {t("dso.analytics.sections.meter_profile.body")}
        </Box>
      </Typography>
    </Box>
  );
}

export default HelpModalScreen;
